module.exports = __webpack_public_path__ + "img/icons/new/add-white-0c29ea9cce3ff40ec1c8623b545afd7e.svg";